import { Divider, Radio, Table } from 'antd';
// import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

interface Props {
  // Loading
  loading: boolean;
  // Seller Contact List
  getSellerContactList: Function;
  rowDataWarehouse: any;
  totalWarehouse: number;
  selectedSellerContact: React.Key[];
  setSelectedSellerContact: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageSellerContract: Function;
  // Product List
}

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: '셀러 ID',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: '셀러명',
    dataIndex: 'sellerName',
    key: 'sellerName'
  },
  {
    title: '계약 상품',
    dataIndex: 'productName',
    key: 'productName'
  }
];

const SellerContractTable = ({
  rowDataWarehouse,
  totalWarehouse,
  loading,
  selectedSellerContact,
  setSelectedSellerContact,
  handleChangePageSellerContract
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedSellerContact(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedSellerContact,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={rowDataWarehouse}
        pagination={{
          pageSize: 10,
          total: totalWarehouse,
          onChange: (newPage: number) => {
            handleChangePageSellerContract(newPage);
          }
        }}
      />
    </div>
  );
};

export default SellerContractTable;
